webpackJsonp([8],{

/***/ 1266:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1267);
    var insertCss = __webpack_require__(813);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Search.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Search.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1267:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(812)(false);
// imports


// module
exports.push([module.i, ".HgbwD{width:1180px;margin:24px auto}.FlLDo{display:block;margin:0 auto}._3HOd8,._3pN9R,.zP-vG{margin-top:34px;text-align:center;font-size:26px;color:#36404a;font-weight:600}._3pN9R{margin:34px 0 24px;text-align:left}._20szm{color:#ff773a;max-width:750px;overflow:hidden;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis;display:inline-block;vertical-align:bottom}", ""]);

// exports
exports.locals = {
	"courseResult": "HgbwD",
	"noresultImg": "FlLDo",
	"noresult": "_3HOd8",
	"result": "_3pN9R",
	"searching": "zP-vG",
	"item": "_20szm"
};

/***/ }),

/***/ 1268:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "19834bf2.png";

/***/ }),

/***/ 1298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(203);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(341);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/isomorphic-style-loader/lib/withStyles.js
var withStyles = __webpack_require__(815);
var withStyles_default = /*#__PURE__*/__webpack_require__.n(withStyles);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(849);

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 15 modules
var redux_es = __webpack_require__(205);

// EXTERNAL MODULE: ./src/routes/search/Search.css
var search_Search = __webpack_require__(1266);
var Search_default = /*#__PURE__*/__webpack_require__.n(search_Search);

// EXTERNAL MODULE: ./src/actions/search.js
var search = __webpack_require__(345);

// EXTERNAL MODULE: ./src/routes/search/noResult.png
var noResult = __webpack_require__(1268);
var noResult_default = /*#__PURE__*/__webpack_require__.n(noResult);

// EXTERNAL MODULE: ./src/components/global/Layout/index.js + 4 modules
var Layout = __webpack_require__(918);

// EXTERNAL MODULE: ./src/components/common/CourseCard/index.js
var CourseCard = __webpack_require__(952);

// EXTERNAL MODULE: ./src/components/common/LoadMore/index.js
var LoadMore = __webpack_require__(955);

// EXTERNAL MODULE: ./src/core/utils.js
var utils = __webpack_require__(204);

// CONCATENATED MODULE: ./src/routes/search/Search.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var Search__ref = _jsx('span', {}, void 0, '\u4EE5\u4E0B\u662F\u6709\u5173\xA0');

var Search_Search = function (_React$Component) {
  _inherits(Search, _React$Component);

  function Search(props) {
    _classCallCheck(this, Search);

    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));

    _this.loadMore = _this.loadMore.bind(_this);
    return _this;
  }

  _createClass(Search, [{
    key: 'loadMore',
    value: function loadMore() {
      var _props = this.props,
          searchItem = _props.searchItem,
          searchResult = _props.searchResult,
          fetchSearchMore = _props.fetchSearchMore;

      return fetchSearchMore(searchItem, searchResult.courses.length);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          searchItem = _props2.searchItem,
          searchResult = _props2.searchResult,
          isSearching = _props2.isSearching,
          searchResultHasMore = _props2.searchResultHasMore;
      var courses = searchResult.courses;

      if (isSearching) {
        return _jsx(Layout["a" /* default */], {}, void 0, _jsx('div', {
          className: Search_default.a.searching
        }, void 0, '\u62FC\u547D\u641C\u7D22\u4E2D...'));
      }

      if (!courses || !courses.length) {
        return _jsx(Layout["a" /* default */], {}, void 0, _jsx('img', {
          src: noResult_default.a,
          className: Search_default.a.noresultImg,
          alt: '无结果'
        }), _jsx('div', {
          className: Search_default.a.noresult
        }, void 0, '\u5171\u641C\u7D22\u52300\u95E8\xA0', _jsx('span', {
          className: Search_default.a.item
        }, void 0, searchItem), '\xA0\u6709\u5173\u8BFE\u7A0B'));
      }
      return _jsx(Layout["a" /* default */], {}, void 0, courses.length ? _jsx('div', {
        className: Search_default.a.courseResult
      }, void 0, _jsx('div', {
        className: Search_default.a.result
      }, void 0, Search__ref, _jsx('span', {
        className: Search_default.a.item
      }, void 0, searchItem), '\xA0\u7684\u5168\u90E8\u8BFE\u7A0B'), _jsx('div', {}, void 0, courses.map(function (course, idx) {
        return _jsx(CourseCard["a" /* default */], {
          inLoc: 'web_search',
          data: course,
          onClick: function onClick() {
            Object(utils["i" /* trackEventLog */])('w/search');
          }
        }, 'search_course_' + idx);
      })), _jsx(LoadMore["a" /* default */], {
        onReachBottom: this.loadMore,
        hasMore: searchResultHasMore
      })) : null);
    }
  }]);

  return Search;
}(react_default.a.Component);

function mapStateToProps(state) {
  return {
    isSearching: state.search.isSearching,
    searchItem: state.search.searchItem,
    searchResult: state.search.searchResult,
    searchResultHasMore: state.search.searchResultHasMore
  };
}

function mapDispatchToProps(dispatch) {
  return Object(redux_es["b" /* bindActionCreators */])(search, dispatch);
}

/* harmony default export */ var routes_search_Search = (Object(es["a" /* connect */])(mapStateToProps, mapDispatchToProps)(withStyles_default()(Search_default.a)(Search_Search)));
// CONCATENATED MODULE: ./src/routes/search/index.js
var search__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var action = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
    var store = _ref2.store,
        params = _ref2.params;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return store.dispatch(Object(search["fetchSearch"])(params.wd));

          case 2:
            if (true && window.NProgress) {
              window.NProgress.done();
            }

            return _context.abrupt('return', {
              chunks: ['search'],
              title: '搜索结果-有道精品课-为你精选好课',
              component: _ref3
            });

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function action(_x) {
    return _ref.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */





var _ref3 = search__jsx(routes_search_Search, {});

/* harmony default export */ var routes_search = __webpack_exports__["default"] = (action);

/***/ }),

/***/ 811:
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ 812:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ 813:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(907);

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = __webpack_require__(909);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Isomorphic CSS style loader for Webpack
 *
 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

var prefix = 's';
var inserted = {};

// Base64 encoding and decoding - The "Unicode Problem"
// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}

/**
 * Remove style/link elements for specified node IDs
 * if they are no longer referenced by UI components.
 */
function removeCss(ids) {
  ids.forEach(function (id) {
    if (--inserted[id] <= 0) {
      var elem = document.getElementById(prefix + id);
      if (elem) {
        elem.parentNode.removeChild(elem);
      }
    }
  });
}

/**
 * Example:
 *   // Insert CSS styles object generated by `css-loader` into DOM
 *   var removeCss = insertCss([[1, 'body { color: red; }']]);
 *
 *   // Remove it from the DOM
 *   removeCss();
 */
function insertCss(styles) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$replace = _ref.replace,
      replace = _ref$replace === undefined ? false : _ref$replace,
      _ref$prepend = _ref.prepend,
      prepend = _ref$prepend === undefined ? false : _ref$prepend;

  var ids = [];
  for (var i = 0; i < styles.length; i++) {
    var _styles$i = (0, _slicedToArray3.default)(styles[i], 4),
        moduleId = _styles$i[0],
        css = _styles$i[1],
        media = _styles$i[2],
        sourceMap = _styles$i[3];

    var id = moduleId + '-' + i;

    ids.push(id);

    if (inserted[id]) {
      if (!replace) {
        inserted[id]++;
        continue;
      }
    }

    inserted[id] = 1;

    var elem = document.getElementById(prefix + id);
    var create = false;

    if (!elem) {
      create = true;

      elem = document.createElement('style');
      elem.setAttribute('type', 'text/css');
      elem.id = prefix + id;

      if (media) {
        elem.setAttribute('media', media);
      }
    }

    var cssText = css;
    if (sourceMap && typeof btoa === 'function') {
      // skip IE9 and below, see http://caniuse.com/atob-btoa
      cssText += '\n/*# sourceMappingURL=data:application/json;base64,' + b64EncodeUnicode((0, _stringify2.default)(sourceMap)) + '*/';
      cssText += '\n/*# sourceURL=' + sourceMap.file + '?' + id + '*/';
    }

    if ('textContent' in elem) {
      elem.textContent = cssText;
    } else {
      elem.styleSheet.cssText = cssText;
    }

    if (create) {
      if (prepend) {
        document.head.insertBefore(elem, document.head.childNodes[0]);
      } else {
        document.head.appendChild(elem);
      }
    }
  }

  return removeCss.bind(null, ids);
}

module.exports = insertCss;

/***/ }),

/***/ 814:
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(836)('wks');
var uid = __webpack_require__(829);
var Symbol = __webpack_require__(816).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ 815:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(862);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(867);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(868);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(872);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(896);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(203);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(341);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(904);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contextTypes = {
  insertCss: _propTypes2.default.func
}; /**
    * Isomorphic CSS style loader for Webpack
    *
    * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE.txt file in the root directory of this source tree.
    */

function withStyles() {
  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  return function wrapWithStyles(ComposedComponent) {
    var WithStyles = function (_Component) {
      (0, _inherits3.default)(WithStyles, _Component);

      function WithStyles() {
        (0, _classCallCheck3.default)(this, WithStyles);
        return (0, _possibleConstructorReturn3.default)(this, (WithStyles.__proto__ || (0, _getPrototypeOf2.default)(WithStyles)).apply(this, arguments));
      }

      (0, _createClass3.default)(WithStyles, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          this.removeCss = this.context.insertCss.apply(undefined, styles);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          setTimeout(this.removeCss, 0);
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(ComposedComponent, this.props);
        }
      }]);
      return WithStyles;
    }(_react.Component);

    var displayName = ComposedComponent.displayName || ComposedComponent.name || 'Component';

    WithStyles.displayName = 'WithStyles(' + displayName + ')';
    WithStyles.contextTypes = contextTypes;
    WithStyles.ComposedComponent = ComposedComponent;

    return (0, _hoistNonReactStatics2.default)(WithStyles, ComposedComponent);
  };
}

exports.default = withStyles;

/***/ }),

/***/ 816:
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ 818:
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(823);
var IE8_DOM_DEFINE = __webpack_require__(852);
var toPrimitive = __webpack_require__(837);
var dP = Object.defineProperty;

exports.f = __webpack_require__(820) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(826)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(816);
var core = __webpack_require__(811);
var ctx = __webpack_require__(851);
var hide = __webpack_require__(822);
var has = __webpack_require__(818);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ 822:
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(819);
var createDesc = __webpack_require__(830);
module.exports = __webpack_require__(820) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 823:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(824);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ 824:
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(878);
var defined = __webpack_require__(834);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ 826:
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ 827:
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ 828:
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ 829:
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ 830:
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 831:
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),

/***/ 832:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_history__ = __webpack_require__(342);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */





function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (window && window.NProgress) {
        window.NProgress.start();
      }
      var urlGenerator = _this.context.urlGenerator;

      if (_this.props.onClick) {
        _this.props.onClick(event);
      }

      if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
        return;
      }

      if (event.defaultPrevented === true) {
        return;
      }

      event.preventDefault();
      if (!/^http/.test(_this.props.to)) {
        __WEBPACK_IMPORTED_MODULE_2__core_history__["a" /* default */].push(urlGenerator(_this.props.to, _this.props.extraParams));
      } else {
        window.open(urlGenerator(_this.props.to, _this.props.extraParams));
        // location.href = urlGenerator(this.props.to)
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Link, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var urlGenerator = this.context.urlGenerator;

      var _props = this.props,
          to = _props.to,
          children = _props.children,
          extraParams = _props.extraParams,
          props = _objectWithoutProperties(_props, ['to', 'children', 'extraParams']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        _extends({
          ref: function ref(a) {
            return _this2.domnode = a;
          },
          href: urlGenerator(to, extraParams)
        }, props, {
          onClick: this.handleClick
        }),
        children
      );
    }
  }]);

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.defaultProps = {
  children: null,
  onClick: function onClick() {
    return false;
  },
  extraParams: null
};

Link.contextTypes = {
  urlGenerator: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func
};

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),

/***/ 833:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(834);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ 834:
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ 835:
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(836)('keys');
var uid = __webpack_require__(829);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ 836:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(811);
var global = __webpack_require__(816);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(828) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ 837:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(824);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 838:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(875)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(855)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ 839:
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ 840:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(823);
var dPs = __webpack_require__(877);
var enumBugKeys = __webpack_require__(843);
var IE_PROTO = __webpack_require__(835)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(853)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(882).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(857);
var enumBugKeys = __webpack_require__(843);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ 842:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ 843:
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(819).f;
var has = __webpack_require__(818);
var TAG = __webpack_require__(814)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ 845:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(883);
var global = __webpack_require__(816);
var hide = __webpack_require__(822);
var Iterators = __webpack_require__(827);
var TO_STRING_TAG = __webpack_require__(814)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(814);


/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(816);
var core = __webpack_require__(811);
var LIBRARY = __webpack_require__(828);
var wksExt = __webpack_require__(846);
var defineProperty = __webpack_require__(819).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 848:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 849:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(203);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(341);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/PropTypes.js

var subscriptionShape = prop_types_default.a.shape({
  trySubscribe: prop_types_default.a.func.isRequired,
  tryUnsubscribe: prop_types_default.a.func.isRequired,
  notifyNestedSubs: prop_types_default.a.func.isRequired,
  isSubscribed: prop_types_default.a.func.isRequired
});
var storeShape = prop_types_default.a.shape({
  subscribe: prop_types_default.a.func.isRequired,
  dispatch: prop_types_default.a.func.isRequired,
  getState: prop_types_default.a.func.isRequired
});
// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/warning.js
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}
// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js





var prefixUnsafeLifecycleMethods = typeof react_default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  warning('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return react["Children"].only(this.props.children);
    };

    return Provider;
  }(react["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: storeShape.isRequired,
    children: prop_types_default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = storeShape.isRequired, _Provider$childContex[subscriptionKey] = subscriptionShape, _Provider$childContex);
  return Provider;
}
/* harmony default export */ var components_Provider = (createProvider());
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/react-redux/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(905);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var browser = __webpack_require__(906);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(343);
var react_is_default = /*#__PURE__*/__webpack_require__.n(react_is);

// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();


// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connectAdvanced.js










var connectAdvanced_prefixUnsafeLifecycleMethods = typeof react_default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = _objectWithoutPropertiesLoose(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = storeShape, _contextTypes[subscriptionKey] = subscriptionShape, _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = subscriptionShape, _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    browser_default()(Object(react_is["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_assertThisInitialized(_assertThisInitialized(_this)));
        browser_default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        browser_default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new Subscription(this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = _extends({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(react["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(react["Component"]);

    if (connectAdvanced_prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = connectAdvanced_prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return hoist_non_react_statics_cjs_default()(Connect, WrappedComponent);
  };
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/shallowEqual.js
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 15 modules
var es = __webpack_require__(205);

// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/isPlainObject.js
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/verifyPlainObject.js


function verifyPlainObject_verifyPlainObject(value, displayName, methodName) {
  if (!isPlainObject(value)) {
    warning(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapDispatchToProps.js


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return Object(es["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ var connect_mapDispatchToProps = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapStateToProps.js

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ var connect_mapStateToProps = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mergeProps.js


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ var connect_mergeProps = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/verifySubselectors.js


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      warning("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors_verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/selectorFactory.js


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutPropertiesLoose(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/connect.js








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? connect_mapStateToProps : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? connect_mapDispatchToProps : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? connect_mergeProps : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ var connect_connect = (createConnect());
// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js
/* unused concated harmony import Provider */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return components_Provider; });
/* unused concated harmony import createProvider */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return createProvider; });
/* unused concated harmony import connectAdvanced */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return connectAdvanced; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return connect_connect; });





/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(818);
var toObject = __webpack_require__(833);
var IE_PROTO = __webpack_require__(835)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(866);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(820) && !__webpack_require__(826)(function () {
  return Object.defineProperty(__webpack_require__(853)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(824);
var document = __webpack_require__(816).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ 854:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(873);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(886);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ 855:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(828);
var $export = __webpack_require__(821);
var redefine = __webpack_require__(856);
var hide = __webpack_require__(822);
var Iterators = __webpack_require__(827);
var $iterCreate = __webpack_require__(876);
var setToStringTag = __webpack_require__(844);
var getPrototypeOf = __webpack_require__(850);
var ITERATOR = __webpack_require__(814)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ 856:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(822);


/***/ }),

/***/ 857:
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(818);
var toIObject = __webpack_require__(825);
var arrayIndexOf = __webpack_require__(879)(false);
var IE_PROTO = __webpack_require__(835)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ 858:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 859:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(857);
var hiddenKeys = __webpack_require__(843).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 860:
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(848);
var createDesc = __webpack_require__(830);
var toIObject = __webpack_require__(825);
var toPrimitive = __webpack_require__(837);
var has = __webpack_require__(818);
var IE8_DOM_DEFINE = __webpack_require__(852);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(820) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 861:
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(842);
var TAG = __webpack_require__(814)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ 862:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(863), __esModule: true };

/***/ }),

/***/ 863:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(864);
module.exports = __webpack_require__(811).Object.getPrototypeOf;


/***/ }),

/***/ 864:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(833);
var $getPrototypeOf = __webpack_require__(850);

__webpack_require__(865)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ 865:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(821);
var core = __webpack_require__(811);
var fails = __webpack_require__(826);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 866:
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ 867:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(869);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ 869:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(870), __esModule: true };

/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(871);
var $Object = __webpack_require__(811).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(821);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(820), 'Object', { defineProperty: __webpack_require__(819).f });


/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(854);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(874), __esModule: true };

/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(838);
__webpack_require__(845);
module.exports = __webpack_require__(846).f('iterator');


/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(839);
var defined = __webpack_require__(834);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(840);
var descriptor = __webpack_require__(830);
var setToStringTag = __webpack_require__(844);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(822)(IteratorPrototype, __webpack_require__(814)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ 877:
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(819);
var anObject = __webpack_require__(823);
var getKeys = __webpack_require__(841);

module.exports = __webpack_require__(820) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(842);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(825);
var toLength = __webpack_require__(880);
var toAbsoluteIndex = __webpack_require__(881);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(839);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(839);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(816).document;
module.exports = document && document.documentElement;


/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(884);
var step = __webpack_require__(885);
var Iterators = __webpack_require__(827);
var toIObject = __webpack_require__(825);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(855)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ 884:
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ 885:
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(887), __esModule: true };

/***/ }),

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(888);
__webpack_require__(893);
__webpack_require__(894);
__webpack_require__(895);
module.exports = __webpack_require__(811).Symbol;


/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(816);
var has = __webpack_require__(818);
var DESCRIPTORS = __webpack_require__(820);
var $export = __webpack_require__(821);
var redefine = __webpack_require__(856);
var META = __webpack_require__(889).KEY;
var $fails = __webpack_require__(826);
var shared = __webpack_require__(836);
var setToStringTag = __webpack_require__(844);
var uid = __webpack_require__(829);
var wks = __webpack_require__(814);
var wksExt = __webpack_require__(846);
var wksDefine = __webpack_require__(847);
var enumKeys = __webpack_require__(890);
var isArray = __webpack_require__(891);
var anObject = __webpack_require__(823);
var isObject = __webpack_require__(824);
var toObject = __webpack_require__(833);
var toIObject = __webpack_require__(825);
var toPrimitive = __webpack_require__(837);
var createDesc = __webpack_require__(830);
var _create = __webpack_require__(840);
var gOPNExt = __webpack_require__(892);
var $GOPD = __webpack_require__(860);
var $GOPS = __webpack_require__(858);
var $DP = __webpack_require__(819);
var $keys = __webpack_require__(841);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(859).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(848).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(828)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(822)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(829)('meta');
var isObject = __webpack_require__(824);
var has = __webpack_require__(818);
var setDesc = __webpack_require__(819).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(826)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 890:
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(841);
var gOPS = __webpack_require__(858);
var pIE = __webpack_require__(848);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(842);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(825);
var gOPN = __webpack_require__(859).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 893:
/***/ (function(module, exports) {



/***/ }),

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(847)('asyncIterator');


/***/ }),

/***/ 895:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(847)('observable');


/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(897);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(901);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(854);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ 897:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(898), __esModule: true };

/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(899);
module.exports = __webpack_require__(811).Object.setPrototypeOf;


/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(821);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(900).set });


/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(824);
var anObject = __webpack_require__(823);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(851)(Function.call, __webpack_require__(860).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(902), __esModule: true };

/***/ }),

/***/ 902:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(903);
var $Object = __webpack_require__(811).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ 903:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(821);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(840) });


/***/ }),

/***/ 904:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),

/***/ 905:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(343);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 906:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(908), __esModule: true };

/***/ }),

/***/ 908:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(811);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(910);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(913);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 910:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(911), __esModule: true };

/***/ }),

/***/ 911:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(845);
__webpack_require__(838);
module.exports = __webpack_require__(912);


/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(861);
var ITERATOR = __webpack_require__(814)('iterator');
var Iterators = __webpack_require__(827);
module.exports = __webpack_require__(811).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 913:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(914), __esModule: true };

/***/ }),

/***/ 914:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(845);
__webpack_require__(838);
module.exports = __webpack_require__(915);


/***/ }),

/***/ 915:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(823);
var get = __webpack_require__(916);
module.exports = __webpack_require__(811).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 916:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(861);
var ITERATOR = __webpack_require__(814)('iterator');
var Iterators = __webpack_require__(827);
module.exports = __webpack_require__(811).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ 917:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchStatus", function() { return fetchStatus; });
/* harmony export (immutable) */ __webpack_exports__["statusFetch"] = statusFetch;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchRemind", function() { return fetchRemind; });
/* harmony export (immutable) */ __webpack_exports__["remindFetch"] = remindFetch;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancelRemind", function() { return cancelRemind; });
/* harmony export (immutable) */ __webpack_exports__["cancelUserRemind"] = cancelUserRemind;
/* harmony export (immutable) */ __webpack_exports__["loginOut"] = loginOut;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindMobileEnd", function() { return bindMobileEnd; });
/* harmony export (immutable) */ __webpack_exports__["bindMobile"] = bindMobile;
/* harmony export (immutable) */ __webpack_exports__["forceBindMobile"] = forceBindMobile;
/* harmony export (immutable) */ __webpack_exports__["updateBindMobile"] = updateBindMobile;
/* harmony export (immutable) */ __webpack_exports__["unbindMobile"] = unbindMobile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__creator__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(25);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }


// import storage from '../core/storage';


// 用户信息
var fetchStatus = Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* FETCH_USER_STATUS */], 'data');
function statusFetch() {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState, _ref2) {
      var ds = _ref2.ds;
      var resp, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return ds.userStatus();

            case 2:
              resp = _context.sent;
              _context.next = 5;
              return resp.json();

            case 5:
              data = _context.sent;

              if (!data.error) {
                _context.next = 8;
                break;
              }

              return _context.abrupt('return');

            case 8:
              dispatch(fetchStatus(data));

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function statusFetchAction(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return statusFetchAction;
  }();
}

// 用户提醒
var fetchRemind = Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* FETCH_USER_REMIND */], 'data');
function remindFetch() {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState, _ref4) {
      var ds = _ref4.ds;
      var resp, data;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return ds.userRemind();

            case 2:
              resp = _context2.sent;
              _context2.next = 5;
              return resp.json();

            case 5:
              data = _context2.sent;

              if (data.result) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt('return');

            case 8:
              dispatch(fetchRemind(data));

            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function remindFetchAction(_x4, _x5, _x6) {
      return _ref3.apply(this, arguments);
    }

    return remindFetchAction;
  }();
}

// 不再提醒
var cancelRemind = Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* CANCEL_USER_REMIND */], 'inx');
function cancelUserRemind(inx) {
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState, _ref6) {
      var ds = _ref6.ds;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return ds.cancelRemind(getState().user.remind[inx].hash);

            case 2:
              dispatch(cancelRemind(inx));

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function stopRemindAction(_x7, _x8, _x9) {
      return _ref5.apply(this, arguments);
    }

    return stopRemindAction;
  }();
}

// 退出登录
// export const logOutCurUser = creator(LOG_OUT)
function loginOut(backUrl) {
  return function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState, _ref8) {
      var ds = _ref8.ds;
      var result, data;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return ds.loginOut(backUrl);

            case 3:
              result = _context4.sent;
              _context4.next = 6;
              return result.json();

            case 6:
              data = _context4.sent;

              if (!(data.code === 0)) {
                _context4.next = 9;
                break;
              }

              return _context4.abrupt('return', true);

            case 9:
              return _context4.abrupt('return', false);

            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4['catch'](0);

              console.error('loginOut-error', _context4.t0);
              return _context4.abrupt('return', false);

            case 16:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this, [[0, 12]]);
    }));

    function logoutAction(_x10, _x11, _x12) {
      return _ref7.apply(this, arguments);
    }

    return logoutAction;
  }();
}

// 绑定相关
// 绑定手机号和主账号
var bindMobileEnd = Object(__WEBPACK_IMPORTED_MODULE_0__creator__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BIND_MOBILE */], 'data');
function bindMobile() {
  return function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState, _ref10) {
      var ds = _ref10.ds;
      var resp, data;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return ds.bindMobile();

            case 3:
              resp = _context5.sent;
              _context5.next = 6;
              return resp.json();

            case 6:
              data = _context5.sent;

              dispatch(bindMobileEnd(data));
              _context5.next = 13;
              break;

            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5['catch'](0);

              console.error('绑定手机号异常，请稍后再试', _context5.t0); // eslint-disable-line no-console

            case 13:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this, [[0, 10]]);
    }));

    function bindMobileAction(_x13, _x14, _x15) {
      return _ref9.apply(this, arguments);
    }

    return bindMobileAction;
  }();
}

// 强制绑定手机
function forceBindMobile() {
  return function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState, _ref12) {
      var ds = _ref12.ds;
      var resp, data;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return ds.forceBindMobile();

            case 3:
              resp = _context6.sent;
              _context6.next = 6;
              return resp.json();

            case 6:
              data = _context6.sent;
              return _context6.abrupt('return', data);

            case 10:
              _context6.prev = 10;
              _context6.t0 = _context6['catch'](0);

              console.error('强制绑定手机号异常，请稍后再试', _context6.t0); // eslint-disable-line no-console
              return _context6.abrupt('return', {});

            case 14:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, this, [[0, 10]]);
    }));

    function forceBindMobileAction(_x16, _x17, _x18) {
      return _ref11.apply(this, arguments);
    }

    return forceBindMobileAction;
  }();
}

// 更新绑定手机
function updateBindMobile() {
  return function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch, getState, _ref14) {
      var ds = _ref14.ds;
      var resp, data;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return ds.updateBindMobile();

            case 3:
              resp = _context7.sent;
              _context7.next = 6;
              return resp.json();

            case 6:
              data = _context7.sent;
              return _context7.abrupt('return', data);

            case 10:
              _context7.prev = 10;
              _context7.t0 = _context7['catch'](0);

              console.error('更新绑定手机号异常，请稍后再试', _context7.t0); // eslint-disable-line no-console
              return _context7.abrupt('return', {});

            case 14:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, this, [[0, 10]]);
    }));

    function updateBindMobileAction(_x19, _x20, _x21) {
      return _ref13.apply(this, arguments);
    }

    return updateBindMobileAction;
  }();
}
// 解绑手机号和主账号, 未使用
// export const unbindMobileEnd = creator(UNBIND_MOBILE, 'data')
function unbindMobile() {
  return function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch, getState, _ref16) {
      var ds = _ref16.ds;
      var resp, data;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return ds.unbindMobile();

            case 3:
              resp = _context8.sent;
              _context8.next = 6;
              return resp.json();

            case 6:
              data = _context8.sent;
              return _context8.abrupt('return', data);

            case 10:
              _context8.prev = 10;
              _context8.t0 = _context8['catch'](0);

              console.error('解绑手机号异常，请稍后再试', _context8.t0); // eslint-disable-line no-console
              return _context8.abrupt('return', {});

            case 14:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, this, [[0, 10]]);
    }));

    function unbindMobileAction(_x22, _x23, _x24) {
      return _ref15.apply(this, arguments);
    }

    return unbindMobileAction;
  }();
}

/***/ }),

/***/ 918:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(203);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(341);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/isomorphic-style-loader/lib/withStyles.js
var withStyles = __webpack_require__(815);
var withStyles_default = /*#__PURE__*/__webpack_require__.n(withStyles);

// EXTERNAL MODULE: ./node_modules/normalize.css/normalize.css
var normalize = __webpack_require__(919);
var normalize_default = /*#__PURE__*/__webpack_require__.n(normalize);

// EXTERNAL MODULE: ./src/components/global/Layout/Layout.css
var Layout = __webpack_require__(921);
var Layout_default = /*#__PURE__*/__webpack_require__.n(Layout);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(849);

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 15 modules
var redux_es = __webpack_require__(205);

// EXTERNAL MODULE: ./src/actions/user.js
var user = __webpack_require__(917);

// EXTERNAL MODULE: ./src/actions/search.js
var search = __webpack_require__(345);

// EXTERNAL MODULE: ./src/actions/login.js
var login = __webpack_require__(344);

// EXTERNAL MODULE: ./src/components/global/Header/index.css
var global_Header = __webpack_require__(923);
var Header_default = /*#__PURE__*/__webpack_require__.n(global_Header);

// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(111);

// EXTERNAL MODULE: ./src/core/utils.js
var utils = __webpack_require__(204);

// EXTERNAL MODULE: ./src/components/common/Link/index.js
var Link = __webpack_require__(832);

// EXTERNAL MODULE: ./src/components/global/Header/logo.png
var logo = __webpack_require__(933);
var logo_default = /*#__PURE__*/__webpack_require__.n(logo);

// EXTERNAL MODULE: ./src/core/history.js
var core_history = __webpack_require__(342);

// EXTERNAL MODULE: ./src/components/global/SearchBox/ic_Clear.png
var ic_Clear = __webpack_require__(934);
var ic_Clear_default = /*#__PURE__*/__webpack_require__.n(ic_Clear);

// EXTERNAL MODULE: ./src/components/global/SearchBox/ic_Search.png
var ic_Search = __webpack_require__(935);
var ic_Search_default = /*#__PURE__*/__webpack_require__.n(ic_Search);

// EXTERNAL MODULE: ./src/components/global/SearchBox/ic_Search_Active.png
var ic_Search_Active = __webpack_require__(936);
var ic_Search_Active_default = /*#__PURE__*/__webpack_require__.n(ic_Search_Active);

// EXTERNAL MODULE: ./src/components/global/SearchBox/index.css
var global_SearchBox = __webpack_require__(937);
var SearchBox_default = /*#__PURE__*/__webpack_require__.n(global_SearchBox);

// CONCATENATED MODULE: ./src/components/global/SearchBox/index.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SearchBox__ref = _jsx('span', {}, void 0, '\u70ED\u95E8\u641C\u7D22');

var _ref2 = _jsx('span', {}, void 0, '\u641C\u7D22\u5386\u53F2');

var SearchBox_SearchBox = function (_React$Component) {
  _inherits(SearchBox, _React$Component);

  function SearchBox(props) {
    _classCallCheck(this, SearchBox);

    var _this = _possibleConstructorReturn(this, (SearchBox.__proto__ || Object.getPrototypeOf(SearchBox)).call(this, props));

    _this.fetchSuggest = function (val) {
      var fetch = _this.context.fetch;

      fetch(config["p" /* SERVER */] + 'suggest?n=5&q=' + window.encodeURIComponent(val)).then(function (res) {
        return res.json();
      }).then(function (resData) {
        var msg = resData.msg,
            data = resData.data;

        if (msg !== 'success') return;
        _this.setState({
          searchType: 'suggest',
          focusIdx: -1,
          searchSuggest: data
        });
      });
    };

    _this.handleFocus = function () {
      Object(utils["i" /* trackEventLog */])('w/header/searchbar');
      var _this$state = _this.state,
          inputVal = _this$state.inputVal,
          searchType = _this$state.searchType;

      _this.setState({
        showContent: true,
        icSearchState: 1,
        showDel: !!inputVal
      });
      window.clearTimeout(_this.blurTimeout);
      if (inputVal || searchType === 'history') return;
      _this.setState({
        searchType: 'history',
        focusIdx: -1
      });
    };

    _this.handleBlur = function () {
      _this.setState({
        icSearchState: 0
      });
      _this.blurTimeout = window.setTimeout(function () {
        _this.setState({
          searchType: '',
          showDel: false,
          focusIdx: -1
        });
      }, 150);
    };

    _this.handleChange = function () {
      // if (this.searchInput.value.length > 16) return
      _this.setState({ inputVal: _this.searchInput.value });
      window.clearTimeout(_this.suggestTimeout);
      _this.suggestTimeout = window.setTimeout(function () {
        var searchVal = _this.searchInput.value;
        var trimVal = searchVal.trim();
        if (trimVal) {
          _this.setState({
            showDel: true
          });
          _this.fetchSuggest(trimVal);
          window.clearTimeout(_this.suggestTimeout);
          return;
        }
        _this.setState({
          searchType: 'history',
          focusIdx: -1,
          showDel: false
        });
      }, 300);
    };

    _this.clickItem = function (item) {
      _this.setState({
        inputVal: '',
        searchType: '',
        focusIdx: -1
      });
      var wd = item.replace(/<\/?[^>]+>/gi, '');
      Object(utils["i" /* trackEventLog */])('w/header/search/' + wd);
      core_history["a" /* default */].push('/search/' + wd);
    };

    _this.handleSearch = function () {
      var searchHistory = _this.props.searchHistory;
      var _this$state2 = _this.state,
          focusIdx = _this$state2.focusIdx,
          searchSuggest = _this$state2.searchSuggest,
          searchType = _this$state2.searchType;

      var itemArr = searchType === 'suggest' ? searchSuggest : searchHistory;
      var searchVal = _this.searchInput.value;
      if (focusIdx >= 0) {
        searchVal = itemArr[focusIdx];
      }
      if (!searchVal.trim()) return;
      _this.clickItem(searchVal);
      _this.searchInput.blur();
      Object(utils["i" /* trackEventLog */])('w/header/search');
      window.clearTimeout(_this.suggestTimeout);
    };

    _this.handleKeyDown = function (e) {
      var code = e.keyCode;
      var searchHistory = _this.props.searchHistory;
      var _this$state3 = _this.state,
          focusIdx = _this$state3.focusIdx,
          searchSuggest = _this$state3.searchSuggest,
          searchType = _this$state3.searchType;

      var itemArr = searchType === 'suggest' ? searchSuggest : searchHistory;
      var itemLen = itemArr.length;

      if (code === 13) {
        // enter键：搜索
        _this.handleSearch();
      } else if (code === 38) {
        // 上箭头
        e.preventDefault();
        if (focusIdx < 0) return;
        _this.setState({
          focusIdx: focusIdx - 1
        });
      } else if (code === 40) {
        e.preventDefault();
        if (focusIdx >= itemLen - 1) return;
        _this.setState({
          focusIdx: focusIdx + 1
        });
      }
    };

    _this.state = {
      inputVal: '',
      searchType: '',
      showDel: false,
      searchSuggest: [],
      focusIdx: -1,
      showContent: false,
      icSearchState: 0 // 0表示搜索框blur状态，1表示focus状态
    };
    _this.suggestTimeout = null;
    _this.blurTimeout = null;
    return _this;
  }

  _createClass(SearchBox, [{
    key: 'searchHotWord',
    value: function searchHotWord(value) {
      this.searchInput.value = value;
      this.handleChange();
      this.handleSearch();
    }
  }, {
    key: 'renderHotWord',
    value: function renderHotWord() {
      var _this2 = this;

      var hotWords = this.props.hotWords;

      if (!hotWords || !hotWords.length) return null;
      return _jsx('div', {}, void 0, _jsx('div', {
        className: SearchBox_default.a.delHistory
      }, void 0, SearchBox__ref), _jsx('div', {
        className: SearchBox_default.a.hotWords
      }, void 0, hotWords.map(function (item) {
        return item.type === 2 ? _jsx(Link["a" /* default */], {
          className: SearchBox_default.a.hotWordsItem,
          to: item.url,
          target: '_blank'
        }, item.id, item.title) : _jsx('div', {
          className: SearchBox_default.a.hotWordsItem,
          onClick: function onClick() {
            return _this2.searchHotWord(item.title);
          }
        }, item.id, item.title);
      })));
    }
  }, {
    key: 'renderHistory',
    value: function renderHistory() {
      var _this3 = this;

      var _props = this.props,
          deleteSearchHistory = _props.deleteSearchHistory,
          searchHistory = _props.searchHistory;
      var focusIdx = this.state.focusIdx;

      if (!searchHistory || !searchHistory.length) return null;
      return _jsx('div', {}, void 0, _jsx('div', {
        className: SearchBox_default.a.delHistory
      }, void 0, _ref2, _jsx('span', {
        className: SearchBox_default.a.deleteIcon,
        onClick: function onClick() {
          if (searchHistory.length && window.confirm('确定清空搜索历史吗？')) {
            deleteSearchHistory();
          }
        }
      })), searchHistory.map(function (item, idx) {
        var _cx;

        return _jsx('div', {
          className: Object(utils["d" /* cx */])((_cx = {}, _defineProperty(_cx, SearchBox_default.a.historyItem, true), _defineProperty(_cx, SearchBox_default.a.focusItem, idx === focusIdx), _cx)),
          onClick: function onClick() {
            Object(utils["i" /* trackEventLog */])('w/header/search/history');
            _this3.clickItem(item);
          }
        }, 'history-item-' + (item + idx), item);
      }));
    }
  }, {
    key: 'renderSearch',
    value: function renderSearch() {
      var _this4 = this;

      var _props2 = this.props,
          searchHistory = _props2.searchHistory,
          hotWords = _props2.hotWords;
      var _state = this.state,
          searchType = _state.searchType,
          searchSuggest = _state.searchSuggest,
          showContent = _state.showContent,
          focusIdx = _state.focusIdx;

      switch (searchType) {
        case 'history':
          if ((!searchHistory || !searchHistory.length) && !hotWords) return null;
          return _jsx('div', {
            className: SearchBox_default.a.historyCont + ' ' + SearchBox_default.a.show
          }, void 0, this.renderHotWord(), this.renderHistory());
        case 'suggest':
          if (!searchSuggest.length) {
            return null;
          }
          return _jsx('div', {
            className: SearchBox_default.a.suggestCont + ' ' + (showContent ? SearchBox_default.a.show : '')
          }, void 0, searchSuggest.map(function (item, idx) {
            var _cx2;

            return _jsx('div', {
              className: Object(utils["d" /* cx */])((_cx2 = {}, _defineProperty(_cx2, SearchBox_default.a.suggestItem, true), _defineProperty(_cx2, SearchBox_default.a.focusItem, idx === focusIdx), _cx2)),
              onClick: function onClick() {
                Object(utils["i" /* trackEventLog */])('w/header/search/suggest');
                _this4.clickItem(item);
              }
            }, 'search-suggest-' + (item + idx), item);
          }));
        default:
          return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state2 = this.state,
          icSearchState = _state2.icSearchState,
          inputVal = _state2.inputVal,
          showDel = _state2.showDel;

      return _jsx('div', {
        className: SearchBox_default.a.container
      }, void 0, _jsx('img', {
        onClick: this.handleSearch,
        className: SearchBox_default.a.searchIcon,
        src: icSearchState ? ic_Search_Active_default.a : ic_Search_default.a,
        alt: ''
      }), react_default.a.createElement('input', {
        type: 'text',
        className: SearchBox_default.a.input,
        ref: function ref(_ref3) {
          _this5.searchInput = _ref3;
        },
        placeholder: '输入课程或者老师名称',
        value: inputVal,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown
      }), showDel ? _jsx('img', {
        src: ic_Clear_default.a,
        className: SearchBox_default.a.clearIcon,
        onClick: function onClick() {
          _this5.setState({
            inputVal: ''
          });
          window.setTimeout(function () {
            _this5.searchInput.focus();
          }, 0);
        },
        alt: '清空'
      }) : null, this.renderSearch());
    }
  }]);

  return SearchBox;
}(react_default.a.Component);

SearchBox_SearchBox.contextTypes = {
  fetch: prop_types_default.a.func
};

/* harmony default export */ var components_global_SearchBox = (withStyles_default()(SearchBox_default.a)(SearchBox_SearchBox));
// CONCATENATED MODULE: ./src/components/global/Header/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Header__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Header__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function Header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















function formatTime(time) {
  var date = new Date(time);
  return date.getHours() + ':' + (date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes());
}

var Header__ref2 = Header__jsx('a', {}, void 0, '\u6211\u7684\u8BFE\u7A0B');

var _ref4 = Header__jsx('a', {
  target: '_blank',
  rel: 'noopener noreferrer',
  href: 'https://study.163.com'
}, void 0, '\u7F51\u6613\u4E91\u8BFE\u5802');

var Header_Header = function (_React$Component) {
  Header__inherits(Header, _React$Component);

  function Header() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    Header__classCallCheck(this, Header);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Header__possibleConstructorReturn(this, (_ref = Header.__proto__ || Object.getPrototypeOf(Header)).call.apply(_ref, [this].concat(args))), _this), _this.handleLogin = function (e) {
      var setBackUrl = _this.props.setBackUrl;

      e.preventDefault();
      e.stopPropagation();
      Object(utils["i" /* trackEventLog */])('w/header/login');
      var backUrl = '' + location.pathname + location.search;
      setBackUrl(backUrl);
      core_history["a" /* default */].push('/login');
    }, _this.renderAside = function () {
      var _this$props = _this.props,
          status = _this$props.status,
          remind = _this$props.remind,
          cancelUserRemind = _this$props.cancelUserRemind,
          lowIe = _this$props.lowIe,
          loginOut = _this$props.loginOut,
          mycourseDisabled = _this$props.mycourseDisabled,
          loginDisabled = _this$props.loginDisabled;

      if (lowIe || loginDisabled) return null;
      if (status.id) {
        return Header__jsx('div', {}, void 0, Header__jsx('div', {
          className: Header_default.a.myCoursePanel
        }, void 0, Header__jsx('div', {
          className: Header_default.a.myCourse
        }, void 0, mycourseDisabled ? Header__ref2 : Header__jsx(Link["a" /* default */], {
          to: '/user/mycourse',
          rel: 'noreferrer',
          onClick: function onClick() {
            Object(utils["i" /* trackEventLog */])('w/header/mycourse');
          }
        }, void 0, '\u6211\u7684\u8BFE\u7A0B'), !remind.length ? null : Header__jsx('span', {
          className: Header_default.a.dot
        })), !remind.length ? null : Header__jsx('div', {
          className: Header_default.a.remindWrapper
        }, void 0, Header__jsx('div', {
          className: Header_default.a.remindCont
        }, void 0, Header__jsx('div', {
          className: Header_default.a.triangle
        }), remind.slice(0, 7).map(function (item, inx) {
          return Header__jsx('div', {
            className: Header_default.a.remindItem
          }, 'user-remind-' + item.courseId, Header__jsx(Link["a" /* default */], {
            rel: 'noopener noreferrer',
            target: '_blank',
            to: item.type === 1 ? config["h" /* LIVE_COURSE */] + '?courseId=' + item.courseId + '&lesson=' + item.lessonId + '&liveId=' + item.liveId + '&groupId=' + (item.groupId || -1) : '' + config["f" /* COURSE_DETAIL */] + item.courseId
          }, void 0, Header__jsx('p', {
            className: Header_default.a.title
          }, void 0, item.courseTitle), Header__jsx('div', {
            className: item.type === 1 ? Header_default.a.live : Header_default.a.time
          }, void 0, item.type === 1 ? '上课中' : '\u4ECA\u65E5 ' + formatTime(item.startTime) + '\u8BFE\u7A0B')), Header__jsx('span', {
            onClick: function onClick() {
              return cancelUserRemind(inx);
            },
            className: Header_default.a.close
          }, void 0, '\u4E0D\u518D\u63D0\u9192'));
        })))), Header__jsx('div', {
          className: Header_default.a.avatarPanel
        }, void 0, Header__jsx('div', {
          style: { backgroundImage: 'url(' + status.avatar + ')' },
          className: Header_default.a.avatar
        }, void 0, Header__jsx('div', {
          className: Header_default.a.imgBorder
        })), Header__jsx('div', {
          className: Header_default.a.userCont
        }, void 0, Header__jsx('div', {
          className: Header_default.a.triangle
        }), Header__jsx(Link["a" /* default */], {
          onClick: function onClick() {
            Object(utils["i" /* trackEventLog */])('w/header/account2');
          },
          className: Header_default.a.userItem + ' ' + Header_default.a.accountItem,
          to: config["t" /* WEB_URL_INDEX */] + '/user/account/'
        }, void 0, '\u8D26\u6237\u8BBE\u7F6E'), Header__jsx(Link["a" /* default */], {
          onClick: function onClick() {
            Object(utils["i" /* trackEventLog */])('w/header/order');
          },
          className: Header_default.a.userItem + ' ' + Header_default.a.orderItem,
          to: config["t" /* WEB_URL_INDEX */] + '/user/order/'
        }, void 0, '\u6211\u7684\u8BA2\u5355'), Header__jsx('span', {
          className: Header_default.a.userItem + ' ' + Header_default.a.logoutItem,
          onClick: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
              var result;
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      Object(utils["i" /* trackEventLog */])('w/header/logout');
                      if (mycourseDisabled) {
                        core_history["a" /* default */].push('/');
                      }
                      _context.next = 4;
                      return loginOut();

                    case 4:
                      result = _context.sent;

                      if (result) window.location.reload();

                    case 6:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, _this2);
            }));

            return function onClick() {
              return _ref3.apply(this, arguments);
            };
          }()
        }, void 0, '\u9000\u51FA'))));
      }
      if (true) {
        return Header__jsx('a', {
          onClick: _this.handleLogin,
          rel: 'noreferrer',
          className: Header_default.a.login
        }, void 0, '\u767B\u5F55');
      }
      return null;
    }, _temp), Header__possibleConstructorReturn(_this, _ret);
  }

  Header__createClass(Header, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          remind = _props.remind,
          statusFetch = _props.statusFetch,
          status = _props.status,
          remindFetch = _props.remindFetch,
          lowIe = _props.lowIe;
      // if (remind.length !== 0 || status.id || lowIe) return

      if (lowIe) return;
      if (!status.id) {
        statusFetch();
      }
      if (remind.length === 0) {
        remindFetch();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          searchHistory = _props2.searchHistory,
          fetchSearch = _props2.fetchSearch,
          lowIe = _props2.lowIe,
          deleteSearchHistory = _props2.deleteSearchHistory,
          hotWords = _props2.hotWords;


      return Header__jsx('div', {
        className: Header_default.a.root
      }, void 0, Header__jsx('div', {
        className: Header_default.a.inner
      }, void 0, Header__jsx(Link["a" /* default */], {
        to: '/',
        onClick: function onClick(e) {
          e.preventDefault(); // 阻止默认行为
          Object(utils["i" /* trackEventLog */])('w/header/logo');
          var url = new URL(window.location.origin);
          window.location.replace(url.toString());
        },
        className: Header_default.a.logoLink
      }, void 0, Header__jsx('img', {
        src: logo_default.a,
        className: Header_default.a.logo,
        alt: '有道精品课'
      })), Header__jsx('div', {
        className: Header_default.a.gap
      }), Header__jsx(Link["a" /* default */], {
        onClick: function onClick(e) {
          e.preventDefault(); // 阻止默认行为
          Object(utils["i" /* trackEventLog */])('w/header/index');
          var url = new URL(window.location.origin);
          window.location.replace(url.toString());
        },
        to: '/'
      }, void 0, Header__jsx('span', {
        className: Header_default.a.home
      }, void 0, '\u9996\u9875')), Header__jsx(Link["a" /* default */], {
        onClick: function onClick() {
          Object(utils["i" /* trackEventLog */])('w/header/tools');
        },
        to: '/download'
      }, void 0, 'APP\u4E0B\u8F7D'), _ref4, Header__jsx('a', {
        onClick: function onClick() {
          Object(utils["i" /* trackEventLog */])('w/header/tongdao');
        },
        target: '_blank',
        rel: 'noopener noreferrer',
        href: 'http://c.youdao.com/market/best/bestPc/index.html'
      }, void 0, '\u540C\u9053\u8BA1\u5212'), lowIe ? null : Header__jsx(components_global_SearchBox, {
        searchHistory: searchHistory,
        fetchSearch: fetchSearch,
        hotWords: hotWords,
        deleteSearchHistory: deleteSearchHistory
      }), Header__jsx('div', {
        className: Header_default.a.aside
      }, void 0, this.renderAside())));
    }
  }]);

  return Header;
}(react_default.a.Component);

Header_Header.defaultProps = {
  mycourseDisabled: false,
  loginDisabled: false
};


Header_Header.defaultProps = {
  hotWords: [],
  searchHistory: []
};

function mapStateToProps(state) {
  return {
    searchHistory: state.search.searchHistory,
    hotWords: state.search.hotWords,
    status: state.user.status,
    remind: state.user.remind
  };
}

function mapDispatchToProps(dispatch) {
  return Object(redux_es["b" /* bindActionCreators */])(_extends({}, user, {
    setBackUrl: login["setBackUrl"],
    fetchSearch: search["fetchSearch"],
    deleteSearchHistory: search["deleteSearchHistory"]
  }), dispatch);
}

/* harmony default export */ var components_global_Header = (Object(es["a" /* connect */])(mapStateToProps, mapDispatchToProps)(withStyles_default()(Header_default.a)(Header_Header)));
// EXTERNAL MODULE: ./src/components/global/Sidebar/index.css
var global_Sidebar = __webpack_require__(941);
var Sidebar_default = /*#__PURE__*/__webpack_require__.n(global_Sidebar);

// CONCATENATED MODULE: ./src/components/global/Sidebar/index.js
var Sidebar__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Sidebar__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Sidebar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Sidebar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Sidebar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Sidebar__ref = Sidebar__jsx('p', {}, void 0, '\u5728\u7EBF', Sidebar__jsx('br', {}), '\u5BA2\u670D');

var Sidebar__ref2 = Sidebar__jsx('p', {}, void 0, 'APP', Sidebar__jsx('br', {}), '\u4E0B\u8F7D');

var Sidebar__ref3 = Sidebar__jsx('img', {
  src: 'https://oimageb4.ydstatic.com/image?id=-6617113928986162471&product=xue',
  alt: '\u7CBE\u54C1\u8BFE\u4E8C\u7EF4\u7801'
});

var Sidebar__ref4 = Sidebar__jsx('p', {}, void 0, '\u626B\u63CF\u4E8C\u7EF4\u7801', Sidebar__jsx('br', {}), '\u4E0B\u8F7D\u6709\u9053\u7CBE\u54C1\u8BFE');

var _ref5 = Sidebar__jsx('p', {}, void 0, '\u8FD4\u56DE', Sidebar__jsx('br', {}), '\u9876\u90E8');

var Sidebar_Sidebar = function (_React$Component) {
  Sidebar__inherits(Sidebar, _React$Component);

  Sidebar__createClass(Sidebar, null, [{
    key: 'handleScroll',
    value: function handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (scrollTop > 0) document.getElementById('backTop').style.display = 'block';else document.getElementById('backTop').style.display = 'none';
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      Object(utils["i" /* trackEventLog */])('w/slidebar/top');
      if (document.body.scrollTop === 0) {
        // IE 9
        document.documentElement.scrollTop = 0;
      } else {
        Object(utils["a" /* animateScrollTo */])(document.body, 0);
      }
    }
  }]);

  function Sidebar(props) {
    Sidebar__classCallCheck(this, Sidebar);

    var _this = Sidebar__possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this, props));

    _this.openCustomerService = _this.openCustomerService.bind(_this);
    return _this;
  }

  Sidebar__createClass(Sidebar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', Sidebar.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', Sidebar.handleScroll);
    }
  }, {
    key: 'openCustomerService',
    value: function openCustomerService() {
      Object(utils["i" /* trackEventLog */])('online_service_click', { type: 0 });
      var status = this.props.status;

      var conf = {
        uid: status.id || '',
        data: JSON.stringify([{ key: 'real_name', value: status.nickname }, { key: 'mobile_phone', value: status.mobile }, { index: 0, key: 'account', label: '账号', value: status.id }, { index: 1, key: 'qq', label: 'qq', value: status.qq }])
      };
      window.ysf && window.ysf.config && window.ysf.config(conf); // eslint-disable-line
      window.ysf && window.ysf.open && window.ysf.open(); // eslint-disable-line
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return Sidebar__jsx('div', {
        className: Sidebar_default.a.root
      }, void 0, Sidebar__jsx('div', {
        className: Sidebar_default.a.service
      }, void 0, Sidebar__jsx('span', {
        onClick: function onClick() {
          return _this2.openCustomerService();
        },
        role: 'none'
      }, void 0, Sidebar__jsx('div', {
        className: Sidebar_default.a.icon
      }), Sidebar__ref)), Sidebar__jsx('div', {
        className: Sidebar_default.a.download
      }, void 0, Sidebar__jsx('div', {
        className: Sidebar_default.a.icon
      }), Sidebar__ref2, Sidebar__jsx('div', {
        className: Sidebar_default.a.QRcode
      }, void 0, Sidebar__ref3, Sidebar__ref4)), Sidebar__jsx('div', {
        id: 'backTop',
        className: Sidebar_default.a.backTop
      }, void 0, Sidebar__jsx('a', {
        href: 'javascript:void(0)',
        onClick: Sidebar.handleClick
      }, void 0, Sidebar__jsx('div', {
        className: Sidebar_default.a.icon
      }), _ref5)));
    }
  }]);

  return Sidebar;
}(react_default.a.Component);

function Sidebar_mapStateToProps(state) {
  return {
    status: state.user.status
  };
}

/* harmony default export */ var components_global_Sidebar = (Object(es["a" /* connect */])(Sidebar_mapStateToProps)(withStyles_default()(Sidebar_default.a)(Sidebar_Sidebar)));
// CONCATENATED MODULE: ./src/components/global/Footer/index.js
var Footer__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Footer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Footer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Footer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Footer_LoadFooter = function (_React$PureComponent) {
  Footer__inherits(LoadFooter, _React$PureComponent);

  function LoadFooter() {
    Footer__classCallCheck(this, LoadFooter);

    return Footer__possibleConstructorReturn(this, (LoadFooter.__proto__ || Object.getPrototypeOf(LoadFooter)).apply(this, arguments));
  }

  Footer__createClass(LoadFooter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      try {
        // eslint-disable-next-line no-undef
        web.loadWebFooter(this.instance);
      } catch (error) {
        console.log(error);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return react_default.a.createElement('div', { ref: function ref(el) {
          _this2.instance = el;
        } });
    }
  }]);

  return LoadFooter;
}(react_default.a.PureComponent);

/* harmony default export */ var Footer = (Footer_LoadFooter);
// CONCATENATED MODULE: ./src/components/global/Layout/index.js
var Layout__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */





// external-global styles must be imported in your JS.






var Layout__ref = Layout__jsx(components_global_Sidebar, {});

var Layout__ref2 = Layout__jsx(Footer, {});

function Layout_Layout(props) {
  var children = props.children,
      lowIe = props.lowIe,
      mycourseDisabled = props.mycourseDisabled,
      loginDisabled = props.loginDisabled,
      hasSidebar = props.hasSidebar,
      hasFooter = props.hasFooter;


  return Layout__jsx('div', {}, void 0, Layout__jsx(components_global_Header, {
    lowIe: lowIe,
    mycourseDisabled: mycourseDisabled,
    loginDisabled: loginDisabled
  }), children, lowIe || !hasSidebar ? null : Layout__ref, hasFooter ? Layout__ref2 : null);
}

Layout_Layout.defaultProps = {
  lowIe: false,
  mycourseDisabled: false,
  loginDisabled: false,
  hasSidebar: true,
  hasFooter: true
};


/* harmony default export */ var global_Layout = __webpack_exports__["a"] = (withStyles_default()(normalize_default.a, Layout_default.a)(Layout_Layout));

/***/ }),

/***/ 919:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(920);
    var insertCss = __webpack_require__(813);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../css-loader/index.js??ref--1-rules-1!../postcss-loader/lib/index.js??ref--1-rules-3!./normalize.css", function() {
        content = require("!!../css-loader/index.js??ref--1-rules-1!../postcss-loader/lib/index.js??ref--1-rules-3!./normalize.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 920:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(812)(false);
// imports


// module
exports.push([module.i, "/*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,footer,header,nav,section{display:block}h1{font-size:2em;margin:.67em 0}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{-webkit-box-sizing:content-box;box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}img{border-style:none}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{-webkit-box-sizing:border-box;box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}[hidden],template{display:none}", ""]);

// exports


/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(922);
    var insertCss = __webpack_require__(813);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Layout.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Layout.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 922:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(812)(false);
// imports


// module
exports.push([module.i, "html{color:#222;font-size:16px;font-family:-apple-system,BlinkMacSystemFont,Helvetica Neue,Arial,PingFang SC,Hiragino Sans GB,STHeiti,Microsoft YaHei,Microsoft JhengHei,Source Han Sans SC,Noto Sans CJK SC,Source Han Sans CN,Noto Sans SC,Source Han Sans TC,Noto Sans CJK TC,WenQuanYi Micro Hei,SimSun,sans-serif;line-height:1.375;background:#fff;font-weight:300;min-width:1300px}body{-webkit-box-sizing:border-box;box-sizing:border-box}div{-webkit-box-sizing:inherit;box-sizing:inherit}a,a:active,a:hover,a:visited{text-decoration:none}h1,h2,h3,h4,h5,li,p,ul{margin:0;padding:0}li{list-style:none}::-moz-selection{background:#b3d4fc;text-shadow:none}::selection{background:#b3d4fc;text-shadow:none}hr{display:block;height:1px;border:0;border-top:1px solid #ccc;margin:1em 0;padding:0}audio,canvas,iframe,img,svg,video{vertical-align:middle}fieldset{border:0;margin:0;padding:0}textarea{resize:vertical}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}@media print{*,:after,:before{background:transparent!important;color:#000!important;-webkit-box-shadow:none!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}}.border-b-1px{position:relative}.border-b-1px:after{content:\" \";display:block;width:100%;position:absolute;left:0;bottom:0;border-bottom:1px solid #e6e6e6}@media (-webkit-min-device-pixel-ratio:1.5),(min-device-pixel-ratio:1.5){.border-b-1px:after{-webkit-transform:scaleY(.7);-ms-transform:scaleY(.7);transform:scaleY(.7);-webkit-transform-origin:left bottom;-ms-transform-origin:left bottom;transform-origin:left bottom}.border-t-1px:before{-webkit-transform:scaleY(.7);-ms-transform:scaleY(.7);transform:scaleY(.7);-webkit-transform-origin:left top}}@media (-webkit-min-device-pixel-ratio:2),(min-device-pixel-ratio:2){.border-b-1px:after,.border-t-1px:before{-webkit-transform:scaleY(.5);-ms-transform:scaleY(.5);transform:scaleY(.5)}}.border-t-1px{position:relative}.border-t-1px:before{content:\" \";display:block;width:100%;position:absolute;left:0;top:0;border-top:1px solid #e6e6e6}body{background:#f5f5f5}", ""]);

// exports


/***/ }),

/***/ 923:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(924);
    var insertCss = __webpack_require__(813);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./index.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./index.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 924:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(831);
exports = module.exports = __webpack_require__(812)(false);
// imports


// module
exports.push([module.i, "._2ZgqS{height:60px;background:#ee4137;-webkit-box-shadow:0 3px 10px 0 rgba(0,0,0,.02);box-shadow:0 3px 10px 0 rgba(0,0,0,.02)}.TJb-J{width:1180px;min-width:1180px;height:60px;position:relative;line-height:56px;margin:0 auto}._2in7G{width:140px;height:26px;margin-bottom:6px}._2in7G,.TJb-J>div{vertical-align:middle;display:inline-block}._14s5K{margin-left:30px;background:hsla(0,0%,100%,.3);width:1px;height:32px}._1eNYG{font-weight:1000}.TJb-J>a{vertical-align:middle;display:inline-block;color:#fff;margin-left:30px}.TJb-J>a:last-of-type{margin-right:30px}.TJb-J a.LMmqN{margin:0}._1u03u{color:#fff;display:inline-block;cursor:pointer}.Ufj_i{position:absolute;right:0;top:0}._2GjXc{display:inline-block;vertical-align:middle;color:#fff;position:relative;margin-right:30px}._2GjXc a{color:#fff;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._3rLe5{position:absolute;height:6px;width:6px;border-radius:50%;background:#fad43c;right:-10px;top:18px}._1htcg,._2SfrZ{vertical-align:middle;cursor:pointer;display:inline-block}._2SfrZ{height:56px}._2SfrZ,._3oQDi{position:relative}._3oQDi{top:10px;width:36px;height:36px;border-radius:50%;background-size:contain}._39-pX{position:absolute;width:100%;height:100%;border-radius:50%;border:1px solid #eee}._2AVeu,._379qt{font-weight:300;font-size:14px;-webkit-box-sizing:border-box;box-sizing:border-box;background-color:hsla(0,0%,100%,.96);border:1px solid #ebebeb;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.1);box-shadow:0 2px 4px 0 rgba(0,0,0,.1);border-radius:0 0 4px 4px;z-index:1002}.E0pf_{position:absolute;right:58px;top:45px;display:none;-webkit-transition:opacity .5s 1s;opacity:0;pointer-events:none;padding-top:6px}._379qt{width:378px;margin-top:9px;position:relative}._2AVeu{top:51px;padding:0 20px;width:119px;margin-top:7px;right:-20px;white-space:nowrap;display:none}._2AVeu,._3TFJu{position:absolute}._3TFJu{width:12px;height:7px;top:-7px;right:30px;background-image:url(" + escape(__webpack_require__(925)) + ");background-size:100%;background-repeat:no-repeat}._2SfrZ:hover ._2AVeu{display:block}._1htcg:hover .E0pf_{display:block;-webkit-transition:opacity .5s;opacity:1;pointer-events:auto}._1htcg ._379qt:hover{-webkit-transition:none}.qHZ6Y{display:block;padding-left:21px;background-position:0;background-repeat:no-repeat}.wg1Vt{background-image:url(" + escape(__webpack_require__(926)) + ")}.wg1Vt:hover{background-image:url(" + escape(__webpack_require__(927)) + ")}._2oHps{background-image:url(" + escape(__webpack_require__(928)) + ")}._2oHps:hover{background-image:url(" + escape(__webpack_require__(929)) + ")}.SZOxy{background-image:url(" + escape(__webpack_require__(930)) + ")}.SZOxy:hover{background-image:url(" + escape(__webpack_require__(931)) + ")}._2_L6k,.qHZ6Y{border-bottom:1px solid #ebebeb;height:46px;line-height:46px;color:#818a92}._2_L6k{position:relative;margin:0 20px;height:64px;line-height:16px}._2_L6k a{color:#818a92;display:inline-block;width:280px;white-space:nowrap;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis}.KTMpi{font-size:12px;color:#a7b0b8;line-height:64px;position:absolute;right:0;top:0}._2_L6k:hover,.qHZ6Y:hover{color:#31404c;border-bottom:1px solid #a7b0b8}._2_L6k:hover a{color:#31404c}._385j0{font-size:14px;color:#33404d;padding-top:13px;padding-bottom:7px;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden}._3Binj{font-size:12px;color:#ff773a;padding-right:17px;display:inline-block;background:url(" + escape(__webpack_require__(932)) + ") no-repeat right 0}._2gOTM{font-size:12px;color:#818a92}", ""]);

// exports
exports.locals = {
	"root": "_2ZgqS",
	"inner": "TJb-J",
	"logo": "_2in7G",
	"gap": "_14s5K",
	"home": "_1eNYG",
	"logoLink": "LMmqN",
	"login": "_1u03u",
	"aside": "Ufj_i",
	"myCourse": "_2GjXc",
	"dot": "_3rLe5",
	"myCoursePanel": "_1htcg",
	"avatarPanel": "_2SfrZ",
	"avatar": "_3oQDi",
	"imgBorder": "_39-pX",
	"remindCont": "_379qt",
	"userCont": "_2AVeu",
	"remindWrapper": "E0pf_",
	"triangle": "_3TFJu",
	"userItem": "qHZ6Y",
	"accountItem": "wg1Vt",
	"orderItem": "_2oHps",
	"logoutItem": "SZOxy",
	"remindItem": "_2_L6k",
	"close": "KTMpi",
	"title": "_385j0",
	"live": "_3Binj",
	"time": "_2gOTM"
};

/***/ }),

/***/ 925:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cfc4eb6d.png";

/***/ }),

/***/ 926:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e3d89cc7.png";

/***/ }),

/***/ 927:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ec5ddf6c.png";

/***/ }),

/***/ 928:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "14093bd0.png";

/***/ }),

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b6dcdd52.png";

/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "92c50e27.png";

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2bdf64c0.png";

/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "930c13f1.gif";

/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6d90adc3.png";

/***/ }),

/***/ 934:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "39374f4d.png";

/***/ }),

/***/ 935:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "32aac580.png";

/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "02299a83.png";

/***/ }),

/***/ 937:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(938);
    var insertCss = __webpack_require__(813);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./index.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./index.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(831);
exports = module.exports = __webpack_require__(812)(false);
// imports


// module
exports.push([module.i, "._1nTYW{width:320px;height:44px;position:relative}._1ntKd{position:absolute;left:9px;top:10px;cursor:pointer}._3l-Kp{display:block;padding-left:38px;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;height:100%;border:none;color:#fff;background-color:hsla(0,0%,100%,.2);border-radius:200px}._3l-Kp:focus{background-color:#fff;color:#31404c;outline:transparent}._3l-Kp::-webkit-input-placeholder,textarea::-webkit-input-placeholder{color:hsla(0,0%,100%,.7);font-size:16px}._2btci,._3O_cN{width:410px;font-size:14px;-webkit-box-sizing:border-box;box-sizing:border-box;padding:0 20px;position:absolute;top:52px;left:0;background-color:hsla(0,0%,100%,.96);border:1px solid #ebebeb;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.1);box-shadow:0 2px 4px 0 rgba(0,0,0,.1);border-radius:0 0 4px 4px;z-index:1002;visibility:hidden}._2btci{max-height:351px;overflow:auto;font-size:14px}._1aHnD{visibility:visible}._3O_cN>div:last-child{border-bottom:none}._3tnbo,._3Wl2o{border-bottom:1px solid #ebebeb;height:46px;line-height:46px;color:#818a92;overflow:hidden;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis;cursor:pointer}._3tnbo:hover,._3Wl2o:hover,._13gk8{color:#31404c;border-bottom:1px solid #a7b0b8}._1DrqL{margin-top:20px;height:24px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer}._1DrqL>span{font-weight:500;font-size:16px}._1UdBR{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0 0 20px -20px}._9bjXu{margin:16px 0 0 20px;padding:8px 12px;max-width:360px;line-height:1;border-radius:8px;color:#fc4b3f;background:#ffe2e0;cursor:pointer;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}._9bjXu:hover{background:#ffeceb}.aRmKH{width:24px;height:24px;margin-right:4px;background-image:url(" + escape(__webpack_require__(939)) + ");background-size:contain}.aRmKH:hover{background-image:url(" + escape(__webpack_require__(940)) + ")}._122v0{position:absolute;right:13px;top:12px;width:20px;height:20px}._3l-Kp::-ms-clear{display:none}", ""]);

// exports
exports.locals = {
	"container": "_1nTYW",
	"searchIcon": "_1ntKd",
	"input": "_3l-Kp",
	"historyCont": "_2btci",
	"suggestCont": "_3O_cN",
	"show": "_1aHnD",
	"historyItem": "_3Wl2o",
	"suggestItem": "_3tnbo",
	"focusItem": "_13gk8",
	"delHistory": "_1DrqL",
	"hotWords": "_1UdBR",
	"hotWordsItem": "_9bjXu",
	"deleteIcon": "aRmKH",
	"clearIcon": "_122v0"
};

/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1386bc67.png";

/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "20bb1226.png";

/***/ }),

/***/ 941:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(942);
    var insertCss = __webpack_require__(813);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./index.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./index.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 942:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(831);
exports = module.exports = __webpack_require__(812)(false);
// imports


// module
exports.push([module.i, "._3UE4T{position:fixed;right:10px;bottom:100px;width:60px;border-radius:4px;text-align:center;padding:15.2px 0 10px;font-size:12px;z-index:100}._3UE4T,._7tmFB{border:1px solid #ebebeb;background:#fff}._3UE4T,._3UE4T a{color:#818a92}._2E3aw:hover ._7tmFB{display:block}._2E3aw,.d0ukw{cursor:pointer}._2E3aw:hover>p,._3zv-v a:hover,.d0ukw:hover,.d0ukw:hover>p{color:#ff4c38}._3zv-v{display:none}._1nszA{margin:0 auto;width:30px;height:30px;background-repeat:no-repeat;background-size:100% 100%}.d0ukw ._1nszA{background-image:url(" + escape(__webpack_require__(943)) + ")}.d0ukw:hover ._1nszA{background-image:url(" + escape(__webpack_require__(944)) + ")}._2E3aw ._1nszA{background-image:url(" + escape(__webpack_require__(945)) + ")}._2E3aw:hover ._1nszA{background-image:url(" + escape(__webpack_require__(946)) + ")}._3zv-v ._1nszA{background-image:url(" + escape(__webpack_require__(947)) + ")}._3zv-v:hover ._1nszA{background-image:url(" + escape(__webpack_require__(948)) + ")}._2E3aw:before,._3zv-v:before{content:\"\";display:block;margin:0 auto;width:42px;height:1px;background-color:#f5f5f5;margin-top:10px;margin-bottom:12px}._7tmFB{position:absolute;display:none;top:-67px;left:-160px;width:160px;height:210px;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.1);box-shadow:0 2px 4px 0 rgba(0,0,0,.1)}._7tmFB img{background:#fff;border:1px solid #ebebeb;width:140px;height:140px;margin:10px 0 12px}._7tmFB p{font-size:14px}._2E3aw{position:relative}", ""]);

// exports
exports.locals = {
	"root": "_3UE4T",
	"QRcode": "_7tmFB",
	"download": "_2E3aw",
	"service": "d0ukw",
	"backTop": "_3zv-v",
	"icon": "_1nszA"
};

/***/ }),

/***/ 943:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "143061cb.png";

/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2d11dc5b.png";

/***/ }),

/***/ 945:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f3569bb9.png";

/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "80d1e9f5.png";

/***/ }),

/***/ 947:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "51b42257.png";

/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e3d71abc.png";

/***/ }),

/***/ 949:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export leftPad */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatSingleNumber; });
/* unused harmony export formatTime */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSerialPrice; });

var leftPad = function leftPad(origin, targetLength, padding) {
  if (('' + origin).length < targetLength) {
    return leftPad(padding + origin, targetLength, padding);
  }
  return origin;
};

var formatSingleNumber = function formatSingleNumber(target) {
  return leftPad(target, 2, '0');
};

var formatTime = function formatTime(timeStamp) {
  var TimeObj = new Date(timeStamp);
  var year = TimeObj.getYear() + 1900;
  var month = TimeObj.getMonth() + 1;
  var date = TimeObj.getDate();
  var hour = TimeObj.getHours();
  var minute = TimeObj.getMinutes();
  return year + '.' + formatSingleNumber(month) + '.' + formatSingleNumber(date) + ' ' + formatSingleNumber(hour) + ':' + formatSingleNumber(minute);
};
// 获取组合卡片系列课程的价格
var getSerialPrice = function getSerialPrice(minPrice, maxPrice) {
  if (minPrice === maxPrice) {
    return minPrice;
  }
  return minPrice + ' - ' + maxPrice;
};



/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6e386af0.png";

/***/ }),

/***/ 951:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(949);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var CountDown = function (_React$Component) {
  _inherits(CountDown, _React$Component);

  function CountDown(props) {
    _classCallCheck(this, CountDown);

    var _this = _possibleConstructorReturn(this, (CountDown.__proto__ || Object.getPrototypeOf(CountDown)).call(this, props));

    _this.secondsToTime = function () {
      var secs = _this.props.deadTime - _this.state.timeNow;
      secs = Math.floor(secs / 1000);
      var day = Math.floor(secs / (60 * 60 * 24));
      var divisorForHours = secs % (60 * 60 * 24);
      var hours = Math.floor(divisorForHours / (60 * 60));
      var divisorForMinutes = secs % (60 * 60);
      var minutes = Math.floor(divisorForMinutes / 60);

      var divisorForSeconds = divisorForMinutes % 60;
      var seconds = Math.ceil(divisorForSeconds);

      var formatTime = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* formatSingleNumber */])(hours) + ':' + Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* formatSingleNumber */])(minutes) + ':' + Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* formatSingleNumber */])(seconds);
      if (day > 0) return day + '\u5929' + formatTime;
      return formatTime;
    };

    _this.countDown = function () {
      var _this$props = _this.props,
          callback = _this$props.callback,
          deadTime = _this$props.deadTime;

      if (deadTime > new Date().getTime()) {
        _this.setState({
          timeNow: new Date().getTime()
        });
      } else {
        clearInterval(_this.timer);
        callback();
      }
    };

    _this.state = {
      timeNow: new Date().getTime()
    };
    _this.timer = null;
    return _this;
  }

  _createClass(CountDown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // 为了避免服务端和客户端渲染的不一致，只能在 didmount 后来做初始化了
      this.setState({
        timeNow: new Date().getTime()
      });
      this.timer = setInterval(this.countDown, 1000);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }, {
    key: 'render',
    value: function render() {
      return _jsx('span', {}, void 0, this.secondsToTime());
    }
  }]);

  return CountDown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CountDown.defaultProps = {
  deadTime: new Date().getTime()
};


/* harmony default export */ __webpack_exports__["a"] = (CountDown);

/***/ }),

/***/ 952:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CountDown__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_static_avatarDefault_png__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_static_avatarDefault_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_static_avatarDefault_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Link__ = __webpack_require__(832);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * 课程卡片
 * 运营信息分类：
 * 1. 免费课：salePrice === 0
 * 2. 限时优惠：promotionType === 2
 *     到时间后显示原价
 * 3. 限量优惠：promotionType === 1
 * 4. 限量报名： promotionType === 8
 * 6. 限时报名开售后 前端判断时间 promotionType === 9
 *      到时间后显示售罄
 * 7. 售罄 status === 2
 */




// import Link from '../Link'






var getCourseLink = function getCourseLink(data, id, serialCourse) {
  // 系列课单独处理
  if (serialCourse) return '/serial/' + id;
  switch (data.itemType) {
    case 2:
      // 兼容套餐课程
      return '/course/package/coupon/' + data.id;
    default:
      return '' + __WEBPACK_IMPORTED_MODULE_5__config__["f" /* COURSE_DETAIL */] + data.id;
  }
};

var _ref = _jsx('p', {}, void 0, '\xA0');

var _ref5 = _jsx('span', {}, void 0, '\uFFE5');

var _ref6 = _jsx('span', {}, void 0, '\uFFE5');

var _ref8 = _jsx('ins', {}, void 0, '|');

var CourseCard = function (_React$Component) {
  _inherits(CourseCard, _React$Component);

  _createClass(CourseCard, null, [{
    key: 'renderSaleOut',
    value: function renderSaleOut() {
      return _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.saleOut
      }, void 0, '\u552E\u7F44');
    }
  }]);

  function CourseCard(props) {
    _classCallCheck(this, CourseCard);

    var _this = _possibleConstructorReturn(this, (CourseCard.__proto__ || Object.getPrototypeOf(CourseCard)).call(this, props));

    _this.state = {
      inLimitTimePromotion: true, // 标记是否限时优惠到时间，需要恢复原价
      limitSalePromotionFinished: false // 标记限时报名是否到时间，需要显示售罄
    };
    _this.setLimitPromotionFinished = _this.setLimitPromotionFinished.bind(_this);
    _this.setLimitSalePromotionFinished = _this.setLimitSalePromotionFinished.bind(_this);
    _this.renderPromotionPrice = _this.renderPromotionPrice.bind(_this);
    _this.renderPureOriginalPrice = _this.renderPureOriginalPrice.bind(_this);
    _this.calcCurPromotionText = _this.calcCurPromotionText.bind(_this);
    _this.calcPriceRender = _this.calcPriceRender.bind(_this);
    _this.calcRootClass = _this.calcRootClass.bind(_this);
    return _this;
  }

  _createClass(CourseCard, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var showLogFuc = this.props.showLogFuc;

      if (showLogFuc) {
        showLogFuc();
      }
    }
  }, {
    key: 'setLimitPromotionFinished',
    value: function setLimitPromotionFinished() {
      this.setState({ inLimitTimePromotion: false });
    }
  }, {
    key: 'setLimitSalePromotionFinished',
    value: function setLimitSalePromotionFinished() {
      this.setState({ limitSalePromotionFinished: true });
    }
  }, {
    key: 'getHiddenStatus',
    value: function getHiddenStatus() {
      var _props = this.props,
          data = _props.data,
          serialCourse = _props.serialCourse;

      if (serialCourse) {
        return serialCourse.hideNum;
      }
      if (data.itemType === 2) {
        return true;
      }
      return data.hideNum && (!data.promotionType || [1, 2, 8, 9].indexOf(data.promotionType) > -1);
    }
  }, {
    key: 'calcCurPromotionText',
    value: function calcCurPromotionText(data) {
      // 限时优惠
      var now = new Date().getTime();
      // 限时优惠套餐倒计时
      if (data.itemType === 2 && data.saleEndTime > now && this.state.inLimitTimePromotion) {
        return _jsx('p', {}, void 0, '\u5269', _jsx(__WEBPACK_IMPORTED_MODULE_6__CountDown__["a" /* default */], {
          deadTime: data.saleEndTime,
          callback: this.setLimitPromotionFinished
        }), '\u6062\u590D\u539F\u4EF7');
      }
      if (data.promotionType === 2 && this.state.inLimitTimePromotion && data.saleEndTime > now) {
        return _jsx('p', {}, void 0, '\u8DDD\u7ED3\u675F:', _jsx(__WEBPACK_IMPORTED_MODULE_6__CountDown__["a" /* default */], {
          deadTime: data.saleEndTime,
          callback: this.setLimitPromotionFinished
        }));
      }
      // 限量优惠 & 限量报名
      if ((data.promotionType === 1 || data.promotionType === 8) && data.limitNum > data.courseSaleNum) {
        return _jsx('p', {}, void 0, '\u9650\u91CF' + data.limitNum + '\u4EBA');
      }

      // 限时报名
      if (data.promotionType === 9 && !this.state.limitSalePromotionFinished && data.registrationDeadline > now) {
        if (now > data.saleStartTime) {
          return _jsx('p', {}, void 0, '\u8DDD\u7ED3\u675F:', _jsx(__WEBPACK_IMPORTED_MODULE_6__CountDown__["a" /* default */], {
            deadTime: data.registrationDeadline,
            callback: this.setLimitSalePromotionFinished
          }));
        }
        return _jsx('p', {}, void 0, '\u8DDD\u5F00\u552E:', _jsx(__WEBPACK_IMPORTED_MODULE_6__CountDown__["a" /* default */], {
          deadTime: data.courseStartTime,
          callback: this.setLimitSalePromotionFinished
        }));
      }

      return _ref;
    }
  }, {
    key: 'calcRootClass',
    value: function calcRootClass() {
      var _props2 = this.props,
          hasBannerLayout = _props2.hasBannerLayout,
          topReco = _props2.topReco;

      return __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.root + ' ' + (hasBannerLayout ? __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.lay3 : __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.lay4) + ' ' + (topReco ? __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.topReco : '');
    }
  }, {
    key: 'calcPriceRender',
    value: function calcPriceRender() {
      var _props3 = this.props,
          data = _props3.data,
          serialCourse = _props3.serialCourse;

      var _ref2 = data || {},
          status = _ref2.status,
          courseSalePrice = _ref2.courseSalePrice,
          courseOriginalPrice = _ref2.courseOriginalPrice,
          promotionType = _ref2.promotionType,
          itemType = _ref2.itemType;
      // 组合卡片系列课程


      if (serialCourse) {
        return this.renderPureOriginalPrice();
      }

      // 售罄 不包含套餐
      if (status !== 1 && itemType !== 2 || this.state.limitSalePromotionFinished) {
        return CourseCard.renderSaleOut();
      }

      // 套餐售磬
      if (status !== 0 && itemType === 2 || this.state.limitSalePromotionFinished) {
        return CourseCard.renderSaleOut();
      }

      // 套餐优惠
      if (itemType === 2 && this.state.inLimitTimePromotion && courseOriginalPrice) {
        return this.renderPromotionPrice();
      }

      // 原价无优惠 || 限时优惠到时间了
      if (courseSalePrice > 0 || courseOriginalPrice === courseSalePrice || promotionType === 2 && !this.state.inLimitTimePromotion) {
        return this.renderPureOriginalPrice();
      }

      // 显示优惠价格
      return this.renderPromotionPrice();
    }
  }, {
    key: 'renderPureOriginalPrice',
    value: function renderPureOriginalPrice() {
      var _props4 = this.props,
          data = _props4.data,
          serialCourse = _props4.serialCourse;

      var _ref3 = serialCourse || {},
          minPrice = _ref3.minPrice,
          maxPrice = _ref3.maxPrice;

      var _ref4 = data || {},
          courseOriginalPrice = _ref4.courseOriginalPrice,
          courseSalePrice = _ref4.courseSalePrice;

      if (courseOriginalPrice || maxPrice && maxPrice !== 0) {
        return _jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.curPrice
        }, void 0, _ref5, serialCourse ? Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* getSerialPrice */])(minPrice, maxPrice) : courseSalePrice);
      }
      return _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.curPrice
      }, void 0, '\u514D\u8D39');
    }
  }, {
    key: 'renderPromotionPrice',
    value: function renderPromotionPrice() {
      var data = this.props.data;

      return _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.price
      }, void 0, _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.original
      }, void 0, '\uFFE5', data.courseOriginalPrice), data.courseSalePrice === 0 ? _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.curPrice
      }, void 0, '\u514D\u8D39') : _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.curPrice
      }, void 0, _ref6, data.courseSalePrice));
    }
  }, {
    key: 'renderCourseTime',
    value: function renderCourseTime() {
      var _props5 = this.props,
          data = _props5.data,
          serialCourse = _props5.serialCourse;

      var _ref7 = serialCourse || {},
          serialType = _ref7.serialType,
          courseCount = _ref7.courseCount;

      var isCouponCourse = data.itemType === 2;
      if (serialCourse) {
        return _jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.serialCourse
        }, void 0, serialType, '\xA0/\xA0\u5171\xA0', courseCount, '\xA0\u95E8\u8BFE');
      } else if (isCouponCourse) {
        // 兼容套餐标签展示
        return _jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.serialCourse
        }, void 0, '\u5957\u9910\u8D2D\u4E70\u66F4\u4F18\u60E0');
      }
      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.time
      }, void 0, '\u65F6\u95F4\uFF1A', data.courseTime || '随到随学', ' ', !data.hideLessonNum && _jsx('span', {}, void 0, _ref8, ' ', data.lessonNum, '\u8BFE\u65F6'));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          data = _props6.data,
          onClick = _props6.onClick,
          inLoc = _props6.inLoc,
          serialCourse = _props6.serialCourse;
      // 普通课，限时优惠，限量优惠，限时报名，限量报名 隐藏数量

      var _ref9 = serialCourse || {},
          id = _ref9.id,
          categoryName = _ref9.categoryName,
          title = _ref9.title,
          saleNum = _ref9.saleNum;

      var hide = this.getHiddenStatus();
      var teacherList = serialCourse ? serialCourse.teacherList : data.teacherList;
      return _jsx(__WEBPACK_IMPORTED_MODULE_8__common_Link__["a" /* default */], {
        to: getCourseLink(data, id, serialCourse),
        extraParams: inLoc ? { inLoc: inLoc, Pdt: 'jpkWeb' } : null,
        target: '_blank',
        rel: 'noopener noreferrer',
        className: this.calcRootClass(),
        onClick: onClick
      }, void 0, _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.category
      }, void 0, serialCourse ? categoryName : data.categoryName), _jsx('strong', {
        className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.title
      }, void 0, serialCourse ? title : data.courseTitle), this.renderCourseTime(), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.teachers
      }, void 0, !teacherList || teacherList.length === 0 ? null : teacherList.slice(0, 3).map(function (teacher) {
        return _jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.teacher
        }, 'coursecard-teacher-' + (data.id ? data.id : id) + '-' + teacher.id + '-' + teacher.name, _jsx('img', {
          className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.avatar,
          src: teacher.imgUrl || __WEBPACK_IMPORTED_MODULE_7__common_static_avatarDefault_png___default.a,
          alt: teacher.name
        }), _jsx('span', {}, void 0, teacher.name));
      })), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.saleInfo
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.left
      }, void 0, _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.promotion + ' ' + (hide ? __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.hideNum : '')
      }, void 0, this.calcCurPromotionText(data || {})), hide ? null : _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.saleNum
      }, void 0, '\u5DF2\u6709', serialCourse ? saleNum : data.courseSaleNum, '\u4EBA\u8D2D\u4E70')), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.right
      }, void 0, this.calcPriceRender())));
    }
  }]);

  return CourseCard;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CourseCard.defaultProps = {
  topReco: false,
  hasBannerLayout: false,
  onClick: function onClick() {},
  inLoc: '',
  serialCourse: null,
  showLogFuc: function showLogFuc() {}
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_3__index_css___default.a)(CourseCard));

/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(954);
    var insertCss = __webpack_require__(813);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./index.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./index.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(812)(false);
// imports


// module
exports.push([module.i, "._1EMem{height:288px;width:280px;overflow:hidden;display:inline-block;-webkit-box-sizing:border-box;box-sizing:border-box;padding:20px;background:#fff;margin:0 20px 20px 0;vertical-align:top}._1EMem,.QvGrY{border-radius:16px}.QvGrY{border-top:2px solid #ffe2e0}.QvGrY:hover{border-top:2px solid #fb4a3e}.QvGrY:nth-child(2){border-top:2px solid #fff0e0}.QvGrY:nth-child(2):hover{border-top:2px solid #ff9830}.QvGrY:nth-child(3){border-top:2px solid #cbefff}.QvGrY:nth-child(3):hover{border-top:2px solid #30baff}.QvGrY:nth-child(4){border-top:2px solid #e0fadc}.QvGrY:nth-child(4):hover{border-top:2px solid #3ccf3c}._1_4E1:nth-child(3),._1EMem:last-child,.YuyDb:nth-child(4n+4){margin-right:0}._1EMem:hover{-webkit-transition:.3s;-o-transition:.3s;transition:.3s;-webkit-box-shadow:0 10px 30px 0 rgba(0,0,0,.1);box-shadow:0 10px 30px 0 rgba(0,0,0,.1);-webkit-transform:translateY(-5px);-ms-transform:translateY(-5px);transform:translateY(-5px)}._8-iAp{display:block;height:18px;width:60px;background:#b0b9c2;border-radius:5px;font-size:12px;color:#fff;line-height:18px;text-align:center;margin-bottom:10px}._1EMem:hover ._8-iAp{background-image:-webkit-linear-gradient(16.7deg,#fb4a3e,#ff7c73);background-image:-o-linear-gradient(16.7deg,#fb4a3e 0,#ff7c73 100%);background-image:linear-gradient(73.3deg,#fb4a3e,#ff7c73);border-radius:2px}.QvGrY:hover ._8-iAp{background:#a7b0b8;-webkit-box-shadow:none;box-shadow:none}._3K30U{font-size:20px;font-weight:600;color:#1f242e;line-height:26px;height:52px;margin-bottom:4px;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}._2uXPi{overflow:hidden;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis;font-size:12px;color:#818a92;font-weight:300}._2uXPi ins{margin:0 2px;text-decoration:none}.zPNv6{font-weight:300;color:#818a92;margin:16px 10px 15px 0}.xj1O0{display:inline-block;text-align:center;margin:0 10px 0 0}._2-jHE{width:40px;height:40px;border-radius:40px;border:1px solid #f5f5f5;margin-bottom:5px}.xj1O0 span{display:block}._3HJ3p,.xj1O0 span{font-size:12px;color:#818a92}._3HJ3p{border-top:1px solid #f5f5f5;padding-top:16px;position:relative;font-weight:400}._3t4co{position:absolute;right:0;bottom:0}.t45av{display:block;color:#ff9830;margin-bottom:2px}._3LXn5,.t45av{font-weight:300}._3LXn5{color:#818a92}._3Yfyo{font-size:22px}._14JkP{font-size:14px;color:#a7b0b8;margin-right:5px;text-decoration:line-through}._2Ekh0,._14JkP{display:inline-block}._2Ekh0{font-size:22px;color:#ff4c38}._2Ekh0 span{color:ff773a;font-size:12px}.YR5_I{display:block;font-size:22px;font-weight:400;color:#a7b0b8}._18ISU{padding-top:14px;margin-bottom:4px}._1vFIe{overflow:hidden}.r7lpZ{height:19px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;text-align:center;line-height:17px;font-family:PingFangSC-Regular;font-size:12px;vertical-align:center;color:#ff905d;background:#fff7f3;border:1px solid #ffe3d6;border-radius:2px;padding:0 10px;margin:-1px 0}", ""]);

// exports
exports.locals = {
	"root": "_1EMem",
	"topReco": "QvGrY",
	"lay3": "_1_4E1",
	"lay4": "YuyDb",
	"category": "_8-iAp",
	"title": "_3K30U",
	"time": "_2uXPi",
	"teachers": "zPNv6",
	"teacher": "xj1O0",
	"avatar": "_2-jHE",
	"saleInfo": "_3HJ3p",
	"right": "_3t4co",
	"promotion": "t45av",
	"saleNum": "_3LXn5",
	"price": "_3Yfyo",
	"original": "_14JkP",
	"curPrice": "_2Ekh0",
	"saleOut": "YR5_I",
	"hideNum": "_18ISU",
	"left": "_1vFIe",
	"serialCourse": "r7lpZ"
};

/***/ }),

/***/ 955:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var scrollTimer = null;

function renderCont(isLoadingMore, hasMore, needGap) {
  if (isLoadingMore) {
    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_2__index_css___default.a.loadText
    }, void 0, '\u6B63\u5728\u52A0\u8F7D...');
  }
  return hasMore && needGap ? _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2__index_css___default.a.loadText
  }, void 0, '\xA0') : _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2__index_css___default.a.loadText
  });
}

var LoadMore = function (_React$Component) {
  _inherits(LoadMore, _React$Component);

  function LoadMore(props) {
    _classCallCheck(this, LoadMore);

    var _this = _possibleConstructorReturn(this, (LoadMore.__proto__ || Object.getPrototypeOf(LoadMore)).call(this, props));

    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.state = {
      isLoadingMore: false
    };
    return _this;
  }

  _createClass(LoadMore, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      var _this2 = this;

      if (scrollTimer) clearTimeout(scrollTimer);
      var _props = this.props,
          onReachBottom = _props.onReachBottom,
          hasMore = _props.hasMore;

      if (hasMore && !this.state.isLoadingMore) {
        scrollTimer = setTimeout(function () {
          _this2.setState({ isLoadingMore: true });
          onReachBottom().then(function () {
            _this2.setState({ isLoadingMore: false });
            clearTimeout(scrollTimer);
          });
        }, 300);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2__index_css___default.a.loadMore
      }, void 0, renderCont(this.state.isLoadingMore, this.props.hasMore, this.props.needGap));
    }
  }]);

  return LoadMore;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LoadMore.defaultProps = {
  needGap: true
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_2__index_css___default.a)(LoadMore));

/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(957);
    var insertCss = __webpack_require__(813);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./index.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./index.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(812)(false);
// imports


// module
exports.push([module.i, "._1GxQH{clear:both;width:100%}._3gk0S{text-align:center;margin:10px 0 5px;color:#b8b8b8;font-size:16px}", ""]);

// exports
exports.locals = {
	"loadMore": "_1GxQH",
	"loadText": "_3gk0S"
};

/***/ })

});


// WEBPACK FOOTER //
// search.adf46bdba.chunk.js